import { FC } from 'react';
import useLocales from '@hooks/useLocales';
import { Alert, Box, Button, Link, Typography } from '@mui/material';
import SvgIconStyle from '@components/SvgIconStyle';
import { SBoldText, SPurpleText, styles } from './styles';

type Props = {
  login: () => void;
  errors: { access?: string; concurrent_session?: string };
};

const LogInBox: FC<Props> = ({ login, errors }) => {
  const { t } = useLocales();
  return (
    <Box sx={styles.container}>
      {errors.access === 'closed' && (
        <Alert severity="warning" sx={styles.warning}>
          {t('login.close_access')}
        </Alert>
      )}
      {errors.concurrent_session === 'detected' && (
        <Alert severity="warning" sx={styles.warning}>
          {t('login.concurrent_session')}
        </Alert>
      )}
      <Box sx={styles.signInBox}>
        <Box sx={styles.iconAndText}>
          <SvgIconStyle src="/icons/iconly/bulk/login.svg" sx={styles.icon} />
          <Typography variant="h4">{t('login.sign_in')}</Typography>
        </Box>
        <Box sx={styles.text}>
          <Typography variant="body1">
            {t('login.to_sign_in')}
            <SBoldText>{t('login.big_purple_dot_db')}</SBoldText>
          </Typography>

          <Typography variant="body1">
            {t('login.you_should')}
            <Link href="https://www.bigpurpledot.com/signup">
              <SPurpleText>{t('login.big_purple_dot_crm')}</SPurpleText>
            </Link>
          </Typography>
        </Box>
        <Button
          size="large"
          color="primary"
          variant="contained"
          sx={styles.signInButton}
          startIcon={<SvgIconStyle src="/icons/login/bpd-small.svg" width={20} height={20} />}
          onClick={login}
        >
          {t('login.sign_in')}
          {t('login.via_bpd_crm')}
        </Button>
      </Box>
    </Box>
  );
};
export default LogInBox;
